let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lseJ2")).then(() => parcelRequire('2gMly'));